export default __webpack_public_path__ + "static/media/insta.3220f4a7.svg";